import React from "react";
import styles from "./css/CityCard.module.css";
import { CityData } from "@/types";
import { EntityInfoSection } from "../pageParts/cityView/EntityInfoSection";
import { useNavigate, useParams } from "react-router-dom";
interface CityCardProps {
    city: CityData; 
}

export const CityCard: React.FC<CityCardProps> = ({ city }) => {
    const {entityName} = useParams();
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/${entityName}/projects/${city.id}`);
    }

    return (
        <div className={styles.cityCard} onClick={handleClick}>
             <EntityInfoSection entity={city} cardMode={true} />
        </div>
    );
};